// The only file in features/home/ that differs between Docs, Sheets and
// Slides — everything else there is a verbatim copy.

import { DriveOpenDialog } from "@/features/docs/DriveOpenDialog";
import { DOC_TEMPLATES } from "@/features/docs/docTemplates";
import type { HomeConfig } from "./homeModel";

export const homeConfig: HomeConfig = {
    appId: "docs",
    noun: "document",
    nounPlural: "documents",
    kind: "doc",
    openable: /\.(docx?|rtf|sfdt|txt)$/i,
    searchTerms: [".doc", ".rtf", ".txt", ".sfdt"],
    localAccept: ".docx,.doc,.rtf,.sfdt,.txt",
    editorPath: "/edit",
    allFilesOption: true,
    accent: {
        solid: "bg-sky-600",
        soft: "bg-sky-50 dark:bg-sky-950/40",
        text: "text-sky-600 dark:text-sky-400"
    },
    thumb: "page",
    templateApp: "docs",
    // Offline fallback only — the start row normally shows the suite's shared templates.
    templates: DOC_TEMPLATES,
    DriveOpenDialog
};
